<template>
  <button
    class="btn--reset info-tooltip"
    type="button"
    :aria-expanded="expanded ? 'true' : 'false'"
    :aria-controls="id"
    tabindex="-1"
    @click="() => expanded = !expanded"
    @focusin="() => expanded = true"
    @focusout="() => expanded = false"
    @mouseenter="() => expanded = true"
    @mouseleave="() => expanded = false"
  >
    <icon identifier="info" />
    <span class="info-tooltip__tooltip" :id="id" :hidden="!expanded">
      <slot />
    </span>
  </button>
</template>

<script>
import Icon from './Icon';

export default {
  components: {
    Icon,
  },

  props: {
    //
  },

  data() {
    return {
      id: (Math.random() * 9999999) + 1111111,
      expanded: false,
    };
  },
};
</script>

<style scoped>
.info-tooltip {
  position: relative;
}

.info-tooltip__tooltip {
  position: absolute;
  bottom: calc(100% + .5rem);
  left: 50%;
  transform: translateX(-50%);
  width: 9.375rem;
  background-color: #fff;
  padding: .75rem;
  border-radius: .375rem;
  box-shadow: 0 2px 10px -3px rgba(0, 0, 2, .4);
  font-size: .875rem;
}

.info-tooltip :global(svg) {
  width: 1em;
  height: 1em;
  fill: #867253;
}
</style>
